!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/escape-html"] = t() : (e.wp = e.wp || {}, e.wp.escapeHtml = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      173: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function __unstableEscapeGreaterThan(e) {
          return e.replace(/>/g, "&gt;");
        };
      }
    },
        t = {};

    function __webpack_require__(r) {
      var a = t[r];
      if (void 0 !== a) return a.exports;
      var s = t[r] = {
        exports: {}
      };
      return e[r](s, s.exports, __webpack_require__), s.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.escapeAmpersand = escapeAmpersand, e.escapeAttribute = function escapeAttribute(e) {
        return (0, a.default)(escapeQuotationMark(escapeAmpersand(e)));
      }, e.escapeEditableHTML = function escapeEditableHTML(e) {
        return escapeLessThan(e.replace(/&/g, "&amp;"));
      }, e.escapeHTML = function escapeHTML(e) {
        return escapeLessThan(escapeAmpersand(e));
      }, e.escapeLessThan = escapeLessThan, e.escapeQuotationMark = escapeQuotationMark, e.isValidAttributeName = function isValidAttributeName(e) {
        return !s.test(e);
      };
      var a = t(__webpack_require__(173));
      var s = /[\u007F-\u009F "'>/="\uFDD0-\uFDEF]/;

      function escapeAmpersand(e) {
        return e.replace(/&(?!([a-z0-9]+|#[0-9]+|#x[a-f0-9]+);)/gi, "&amp;");
      }

      function escapeQuotationMark(e) {
        return e.replace(/"/g, "&quot;");
      }

      function escapeLessThan(e) {
        return e.replace(/</g, "&lt;");
      }
    }(), r;
  }();
});